import React from "react";
import { useSelector } from "react-redux";
import { isEqual } from "lodash";
import "./index.scss"; 
import { convertDate } from "../../../../utils/dateUtils";

const ExtraFields: React.FC<any> = () => {
const remitData = useSelector(
    (state) => state["remitDetailReducer"].remitData,
    isEqual
);

return (
<div>
    <div style={{ marginTop: "15px"}}>
        <div className="extra-fields-detail-container1">
            <div className="extra-fields-container-border">
                <div className="extra-fields-header-container">
                    <span className="mdae-data-field-label">Payee</span>
                </div>
                <div className="extra-fields-sub-header-container">
                    <div className="field-detail-container">
                        <div className="sub-header-field-label"><span className="mdae-data-field-label">Name :</span></div>
                        <div className="mdae-data-field-content">{remitData.extraFields?.payeeName}</div>
                    </div>
                    <div className="field-detail-container">
                        <div className="sub-header-field-label"><span className="mdae-data-field-label">ID Code :</span></div>
                        <div className="mdae-data-field-content">{remitData.extraFields?.payeeIdCode}</div>
                    </div>
                    <div className="field-detail-container">
                        <div className="sub-header-field-label"><span className="mdae-data-field-label">Zip Code :</span></div>
                        <div className="mdae-data-field-content">{remitData.extraFields?.zipCode}</div>
                    </div>
                </div>
            </div>
        </div>                           
    </div>
    <div style={{ display: "flex",marginTop: "20px"}}>
        <div className="extra-fields-detail-container2">
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">Rendering Provider : </span></div>
                <div className="mdae-data-field-content text-overflow-ellipsis" style={{ width: "unset" }} title={remitData.extraFields?.renderingProvider}>{remitData.extraFields?.renderingProvider}</div>
            </div>
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">Rendering Provider NPI : </span></div>
                <div className="mdae-data-field-content">{remitData.extraFields?.renderingProviderNPI}</div>
            </div>
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">COB Carrier Name : </span></div>
                <div className="mdae-data-field-content text-overflow-ellipsis" style={{ width: "unset" }} title={remitData.extraFields?.cobCarrierName}>{remitData.extraFields?.cobCarrierName}</div>
            </div>
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">Claim Receive Date : </span></div>
                <div className="mdae-data-field-content">{convertDate(remitData.extraFields?.claimReceiveDate)}</div>
            </div>                            
        </div>
        <div className="extra-fields-detail-container2 extra-fields-detail-border-left">
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">File Name : </span></div>
                <div className="mdae-data-field-content" style={{ wordBreak: "break-word"}}>{remitData.extraFields?.fileName}</div>
            </div>
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">Date Loaded : </span></div>
                <div className="mdae-data-field-content">{convertDate(remitData.extraFields?.dateLoaded)}</div>
            </div>
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">Payer Remit # : </span></div>
                <div className="mdae-data-field-content">{remitData.extraFields?.payerRemitNo}</div>
            </div>
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">Check # : </span></div>
                <div className="mdae-data-field-content">{remitData.extraFields?.checkNo}</div>
            </div> 
        </div>
        <div className="extra-fields-detail-container2 extra-fields-detail-border-left" style={{ width: "20%"}}>
            <div className="field-detail-container">
                <div className="sub-header-field-label"><span className="mdae-data-field-label">Case ID : </span></div>
                <div className="mdae-data-field-content">{remitData.caseId}</div>
            </div>                            
        </div>
    </div> 
</div>                       
)
}

export default ExtraFields;